import {ScannerTemplateOptions} from "../../../models/scanner-template-options";

export class UpdateScannerDto {

  optionsTitle: string;
  scannerTemplateOptions: ScannerTemplateOptions []
  commonTitle: string;

}
